<!-- navigation -->
<slidenavbar id="slide-nav" [slideDrawer]="slideDrawer"></slidenavbar>

<!-- editor -->
<div id="editor">
    <!-- toggle buttons -->
    <div id="panel-toggle">
        <span class="icon-button" (click)="toggle('imagesOpen')" [ngClass]="{active: imagesOpen}">
            <mat-icon>insert_photo</mat-icon> 
        </span>
    </div>

    <!-- article title -->
    <div class="h1" *ngIf="slideshow.assignment">
        <richtext
            [ngClass]="{warning: slideshow.warning}"
            [(value)]="slideshow.assignment.articleTitle"
            (valueChange)="slideshow.titleChange(slideshow.slides[0])"
            placeholder="Article Title"
            *ngIf="!slideshow.locked; else titleText">
        </richtext>
        <ng-template #titleText>
            <h1 [ngClass]="{faded: !slideshow.assignment.articleTitle}" [innerHTML]="slideshow.assignment.articleTitle ? slideshow.assignment.articleTitle : 'Article Title'"></h1>
        </ng-template>
    </div>
    
    <div class="message" [ngClass]="{showing: slideshow.warning}">Please add a title</div>

    <div #editor id="slide-container">
        <slides [animationComplete]="animationComplete"></slides>
    </div>

</div>
<!-- toggle panel -->
<div id="panel-options" [ngClass]="{open: imagesOpen}">
    <div class="wrap">
        <image-list class="inner {{ imagesOpen ? 'open' : '' }}" (imageClick)="popImageDialog($event)"></image-list>
    </div>
</div>